module.exports = __webpack_public_path__ + "img/affirm_payment_plan_img.5243869.svg";